/* IS/BE Clubhouse — minimal interaction layer. No dependencies. */
(function () {
  "use strict";

  /* ---- Mobile drawer ---- */
  var drawer = document.getElementById("isbe-drawer");
  var toggles = document.querySelectorAll("[data-drawer-toggle]");
  var lastFocus = null;

  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle("open", open);
    drawer.setAttribute("aria-hidden", open ? "false" : "true");
    document.body.style.overflow = open ? "hidden" : "";
    toggles.forEach(function (t) { t.setAttribute("aria-expanded", open ? "true" : "false"); });
    if (open) {
      lastFocus = document.activeElement;
      var first = drawer.querySelector("a, button");
      if (first) first.focus();
    } else if (lastFocus) {
      lastFocus.focus();
    }
  }

  toggles.forEach(function (t) {
    t.addEventListener("click", function () {
      setDrawer(!drawer.classList.contains("open"));
    });
  });
  if (drawer) {
    drawer.addEventListener("click", function (e) {
      if (e.target.closest("a")) setDrawer(false);
    });
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer && drawer.classList.contains("open")) setDrawer(false);
  });

  /* ---- Scroll reveal ---- */
  var revealables = document.querySelectorAll(".rv");
  if (!("IntersectionObserver" in window) || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    revealables.forEach(function (el) { el.classList.add("in"); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("in");
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    revealables.forEach(function (el) { io.observe(el); });
  }

  /* ---- Sticky mobile booking bar: appears once the hero is past ---- */
  var stick = document.getElementById("isbe-stick");
  var sentinel = document.getElementById("isbe-stick-sentinel");
  if (stick && sentinel && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      stick.classList.toggle("show", !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(sentinel);
  } else if (stick) {
    stick.classList.add("show");
  }

  /* ---- Lazy-load iframes (Square calendar, map) only when they scroll into view ---- */
  var frames = document.querySelectorAll("iframe[data-src]");
  if (frames.length) {
    if ("IntersectionObserver" in window) {
      var fio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.src = entry.target.getAttribute("data-src");
            fio.unobserve(entry.target);
          }
        });
      }, { rootMargin: "400px 0px" });
      frames.forEach(function (f) { fio.observe(f); });
    } else {
      frames.forEach(function (f) { f.src = f.getAttribute("data-src"); });
    }
  }
})();
